import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';

// components
import { SbSharedRefineMenuFilterDeliveryOptions } from '../../SbSharedRefineMenu/SbSharedRefineMenuFilters/SbSharedRefineMenuFilterDeliveryOptions';

export const SbRespRefineMenuFilterDeliveryOptionsComponent = props => (
    <SbSharedRefineMenuFilterDeliveryOptions {...props} />
);

export const SbRespRefineMenuFilterDeliveryOptions = createFragmentContainer(
    SbRespRefineMenuFilterDeliveryOptionsComponent,
    {
        viewer: graphql`
            fragment SbRespRefineMenuFilterDeliveryOptions_viewer on Viewer {
                ...SbSharedRefineMenuFilterDeliveryOptions_viewer
            }
        `,
        searchBrowse: graphql`
            fragment SbRespRefineMenuFilterDeliveryOptions_searchBrowse on SearchBrowseQueryConnection {
                ...SbSharedRefineMenuFilterDeliveryOptions_searchBrowse
            }
        `,
    }
);
